import React from "react";
import Flyout, { anchorPoints, offsetContainerHorizontal } from "@weave-design/flyout";
import IconButton from "@weave-design/icon-button";
import { Info16 } from "@weave-design/icons";
import { WeaveDesignStylesheet } from "../../../sharedTypes";

type Props = {
    title?: string;
    children: React.ReactNode;
};

export const ParameterInfo = ({ children, title }: Props) => {
    return (
        <Flyout
            anchorPoint={anchorPoints.TOP_RIGHT}
            alterCoordinates={(coordinates: WeaveDesignStylesheet) => offsetContainerHorizontal(coordinates, -10)}
            content={children}
            openOnHover={true}>
            <IconButton
                icon={<Info16 />}
                title={title || ""} />
        </Flyout>
    );
};
